import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EqualizerState } from './equalizer.reducer';

export const selectEqualizerState = createFeatureSelector<EqualizerState>('equalizer');

export const selectEqualizerPresets = createSelector(
  selectEqualizerState,
  (state: EqualizerState) => state.presets
);

export const selectCurrentEqualizerPreset = createSelector(
  selectEqualizerState,
  (state: EqualizerState) => state.currentPreset
);

export const selectEqualizerEnabled = createSelector(
  selectEqualizerState,
  (state: EqualizerState) => state.isEnabled
);

export const selectDefaultPresets = createSelector(
  selectEqualizerPresets,
  (presets) => presets.filter(p => !p.isCustom)
);

export const selectCustomPresets = createSelector(
  selectEqualizerState,
  (state: EqualizerState) => state.customPresets
);

export const selectCurrentEqualizerBands = createSelector(
  selectCurrentEqualizerPreset,
  (preset) => preset.bands
);
